import { toast } from "react-toastify";
import { ToastCloseButton } from "./ToastCloseButton";
import { theme } from "@utilities";

interface ToastMessage {
    Message: string;
}

export const InfoToast = ({ Message }: ToastMessage) => {
    toast.info(Message, {
        toastId: Message,
        className: "toastInfo",
        closeButton: ToastCloseButton,
        icon: () => <></>,
        progressStyle: { background: theme.colors.toast_info },
    });
};
